import { getPageUrl } from "./getPageUrl";

export { getPageUrl };
